import { useCallback } from "react";

import * as Shared from "../../../../_shared";

export const useVoucherPrice = () => {
	const { viewModel, onSetViewModel } = Shared.Model.Context.useMarketingVoucherEditContext();
	const { voucherPrice } = viewModel;

	const onSetVoucherPriceAmount = useCallback(
		(input: number | undefined) => {
			onSetViewModel([
				{
					key: "voucherPrice",
					value: {
						...voucherPrice,
						amount: {
							isEdited: true,
							value: input!,
						},
					},
				},
			]);
		},
		[onSetViewModel, voucherPrice],
	);

	return {
		voucherPrice,
		onSetVoucherPriceAmount,
	};
};
